import AiSpendBreakdown from '../../../components/AiSpend/AiSpendBreakdown';

export default function AiSpendByFeature() {
  return (
    <AiSpendBreakdown
      dimension="feature"
      title="Feature"
      description="Which product surface the money went to. A feature can span providers, in which case its usage is listed per unit and a per-unit cost is not defined."
    />
  );
}
